export default __webpack_public_path__ + "static/media/appdynamics.02ec76f2f80186d6412371aa70374d74.svg";